import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { GetTipoGastos } from './tipo-gasto.service';
import { Link } from 'react-router-dom';
import { ReadTipoGastoDto } from '@/api.types';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function TipoGastoIndex() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadTipoGastoDto[], number]>();

  const tableState = useDataTableState('descricao');

  const handleBuscar = () => {
    GetTipoGastos((tableState.currentPage - 1) * tableState.pageSize, tableState.pageSize)
      .then((result) => {
        setRegistros([result.objects, result.count]);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.TipoGasto_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadTipoGastoDto>[] = [
    { key: "descricao", header: "Descrição" },
    { key: "coluna1", header: "Coluna 1" },
    { key: "coluna2", header: "Coluna 2" },
    { key: "coluna3", header: "Coluna 3" },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.TipoGasto_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Tipos de Gasto</h3>
          <span className="blockquote-footer pb-4 text-end">
            Cadastro de tipos de gastos do setor.
          </span>
        </div>
        <hr className="pb-4" />

        {registros &&
          <DataTable
            columns={colunas}
            data={registros[0]}
            initialSortKey='descricao'
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros[1]}
          />
        }

      </div>
    </>
  );
}